/*
 * @Author: Chao Yang
 * @Date: 2020-01-20 09:30:35
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 09:28:07
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Account from 'src/app/domain/model/account';
import { DetailProxy } from 'src/app/domain/proxy';
import { InfoService } from '../info';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class DetailService {
  constructor(private _detailProxy: DetailProxy) {}

  getAccounts(
    accounts2: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IProfile[]> {
    return this._detailProxy.getAccounts(accounts2).pipe(
      map((accounts) => {
        accounts.sort((a1, a2) => {
          return a1.accountDescription.localeCompare(a2.accountDescription);
        });
        accounts.forEach((a) => (a.id = a.crmAccountID + '|' + a.fundID));
        return accounts;
      })
    );
  }

  getAuthorizedAccounts(
    accounts2: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IProfile[]> {
    return this._detailProxy.getAuthorizedAccounts(accounts2).pipe(
      map((accounts) => {
        accounts.sort((a1, a2) => {
          return a1.accountDescription.localeCompare(a2.accountDescription);
        });
        accounts.forEach((a) => (a.id = a.crmAccountID + '|' + a.fundID));
        return accounts;
      })
    );
  }

  getAccountTypeColor(): Observable<Account.IColor> {
    return this._detailProxy.getAccountTypeColor();
  }

  getMaxAsOfDate(fundId: number): Observable<string> {
    return this._detailProxy.getMaxAsOfDate(fundId);
  }

  readyToPublish(fundId: number, date: string): Observable<boolean> {
    return this._detailProxy.readyToPublish(fundId, date);
  }

  publish(input: any): Observable<number> {
    return this._detailProxy.publish(input);
  }
}
